import AnimatedLottieView from "@utils/lottieAnimation";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { View, Text, Platform, KeyboardAvoidingView, SafeAreaView, ScrollView, Keyboard, Pressable } from "react-native";
import { actions, RichEditor, RichToolbar } from "react-native-pell-rich-editor";
import { Title } from "@constants/Themed";
import { MaterialIcons } from '@expo/vector-icons';
import styles from "../../../../stylesheet";
import EditorToolbar from "../EditorToolbar/EditorToolbar";
import * as Animatable from 'react-native-animatable';
import { themeSelector } from "@reduxLocal/selectors/themeSelector";

export interface EditorProps {
  placeHolder: string;
  knowledge?: boolean;
  initialContentHTML?: string;
  noBackground?: boolean;
  onFocus?: () => void;
  onChange?: (descriptionText: string) => void;
}

const TempScreen: React.ForwardRefExoticComponent<Omit<EditorProps, "ref"> & React.RefAttributes<unknown>> = forwardRef((props: any, ref) => {
  const { placeHolder, knowledge, initialContentHTML, noBackground, onFocus } = props;
    const [focused, setFocused] = useState(false);
    const toolbarAnim = useRef(null);
    const timeoutRef = useRef(null);
    const theme = themeSelector();

    const _handleSlideOut = () => {
      timeoutRef.current = setTimeout(() => toolbarAnim.current?.slideOutLeft(500).then(() => {
        setFocused(false);
      }), 3000);
    };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }, []);

    return (
      <View style={{ flex: 1 }}>
          {/* {
            Platform.OS === 'web' && focused &&
            <Animatable.View useNativeDriver  style={{ flex: 1, maxWidth: 40, borderRadius: 20, backgroundColor: "rgba(0,0,0,0.2)" }} ref={toolbarAnim} animation={'slideInLeft'}>
              <EditorToolbar
                actions={[
                  actions.undo,
                  actions.setBold,
                  actions.setItalic,
                  actions.setUnderline,
                  actions.setStrikethrough,
                  actions.heading1,
                  actions.alignLeft,
                  actions.alignCenter,
                  actions.insertBulletsList,
                  actions.insertOrderedList,
                  actions.setSuperscript,
                  actions.insertLink
                ]}
                vertical
                ref={ref}
                iconTint="black"
                backgroundColor='rgba(0,0,0,0.2)'
                style={{ borderRadius: 20 }} />
            </Animatable.View>
          } */}
            <RichEditor
              ref={ref as React.RefObject<RichEditor>}
          style={{ backgroundColor: "transparent", borderRadius: 20, flex: 1 }}
              onKeyDown={({ keyCode }) => {
                if (keyCode === 13 && knowledge) {
                  (ref as React.RefObject<RichEditor>).current!.insertText("\n");
                }
              }}
              onFocus={() => {
                onFocus?.();
                if (timeoutRef.current) {
                  clearTimeout(timeoutRef.current);
                }
                if (!focused) {
                  setFocused(true);
                }
              }}
          onBlur={() => { if (Platform.OS === 'web') _handleSlideOut() }}
          editorStyle={{ caretColor: "black", backgroundColor: 'transparent' }}
          placeholder={placeHolder || "Type something.."}
              initialContentHTML={initialContentHTML}
              containerStyle={{ flex: 1, backgroundColor: "transparent",  minHeight: 400, shadowRadius: 20, shadowOpacity: .2, overflow: "scroll" }}
              onChange={descriptionText => {
                props.onChange(descriptionText)
              }}
        />
      </View>
    )
  });
export default TempScreen;
